import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=8fbe749c&scoped=true&"
import script from "./Column.vue?vue&type=script&lang=js&"
export * from "./Column.vue?vue&type=script&lang=js&"
import style0 from "./Column.vue?vue&type=style&index=0&id=8fbe749c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbe749c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fbe749c')) {
      api.createRecord('8fbe749c', component.options)
    } else {
      api.reload('8fbe749c', component.options)
    }
    module.hot.accept("./Column.vue?vue&type=template&id=8fbe749c&scoped=true&", function () {
      api.rerender('8fbe749c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/kanban/components/Column.vue"
export default component.exports